/**
 * Stap 4: de uitslag van de meerkeuzevragen. Per vraag het goede antwoord
 * (groen) en een fout antwoord (rood). Klikt de leerling op een foute vraag,
 * dan staat de passage waar het antwoord staat geel in de tekst links; de
 * eerste foute vraag is al gekozen.
 */
import React from 'react';
import { ChevronRight } from 'lucide-react';
import { TekstPaneel } from '../onderdelen/TekstPaneel';
import { stijlen } from '../stijlen';

export function MeerkeuzeUitslag({ titel, alineas, vragen, antwoorden, uitslag, gekozen, onKiesVraag,
  heeftOpenVragen = true, onVerder, bezig = false }) {
  const passage = gekozen !== null ? uitslag[gekozen]?.relevante_passage : null;
  return (
    <div style={stijlen.toetsRaster}>
      <TekstPaneel titel={titel} alineas={alineas} markeer={passage} />
      <div style={stijlen.toetsPaneel}>
        <h3 style={{ ...stijlen.paneelLabel, marginBottom: 8 }}>Resultaat</h3>
        <div style={{ padding: 16, marginBottom: 24, background: 'var(--anna-maria)', borderRadius: 8, textAlign: 'center' }}>
          <h2 style={{ margin: 0, color: 'var(--inkt)' }}>
            {aantalGoed(uitslag)} van de {uitslag.length} goed!
          </h2>
        </div>
        <p style={{ fontSize: 13, color: 'var(--tekst-3)', marginBottom: 16 }}>
          Klik op een foute vraag om de relevante passage geel gemarkeerd te zien in de tekst.
        </p>

        {uitslag.map((u, i) => {
          const vraag = vragen.find(v => v.id === u.question_id);
          const isGekozen = gekozen === i;
          const aanklikbaar = !u.is_correct && u.relevante_passage;
          const antwoord = antwoorden[u.question_id];
          return (
            <div
              key={u.question_id}
              style={{
                marginBottom: 16,
                padding: 16,
                background: 'var(--vlak)',
                borderRadius: 8,
                cursor: aanklikbaar ? 'pointer' : 'default',
                outline: isGekozen ? '3px solid var(--waarschuw)' : 'none',
                boxShadow: isGekozen ? '0 0 10px rgba(255, 193, 7, 0.5)' : 'none',
              }}
              onClick={() => aanklikbaar && onKiesVraag(isGekozen ? null : i)}
            >
              <p style={{ fontWeight: 500, marginBottom: 12, color: 'var(--inkt)' }}>Vraag {i + 1}: {vraag?.vraag}</p>
              {vraag?.opties && Object.entries(vraag.opties).map(([letter, tekst]) => {
                const goed = letter === u.correct_answer;
                const vanLeerling = letter === antwoord;
                const fout = vanLeerling && !u.is_correct;
                return (
                  <p key={letter} style={{ marginBottom: 4, color: goed ? 'var(--goed)' : (fout ? 'var(--fout)' : 'var(--tekst)') }}>
                    <strong>{letter}.</strong> {tekst}
                    {vanLeerling && ' (jouw antwoord)'}
                  </p>
                );
              })}
              {aanklikbaar && (
                <p style={{ fontSize: 12, color: 'var(--tekst-3)', marginTop: 8, fontStyle: 'italic' }}>
                  {isGekozen ? '📖 De passage is geel gemarkeerd in de tekst hiernaast' : '📖 Klik hier om de passage in de tekst te zien'}
                </p>
              )}
            </div>
          );
        })}

        <button style={{ ...stijlen.groteKnop, marginTop: 16, opacity: bezig ? 0.5 : 1 }} onClick={onVerder} disabled={bezig}>
          {heeftOpenVragen ? 'Verder naar open vragen' : 'Les afronden'} <ChevronRight size={20} />
        </button>
      </div>
    </div>
  );
}

export function aantalGoed(uitslag) {
  return uitslag.filter(u => u.is_correct).length;
}

/** De eerste foute vraag met een passage, of null: die is bij het openen gekozen. */
export function eersteFouteVraag(uitslag) {
  const i = uitslag.findIndex(u => !u.is_correct && u.relevante_passage);
  return i >= 0 ? i : null;
}
